module.exports = __webpack_public_path__ + "img/fb.bddb9253.svg";